/*! @azure/msal-common v6.1.0 2022-02-08 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "6.1.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
